module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-54.29c0e1d0.svg";